import { render, staticRenderFns } from "./RecordedCleanupDialog.vue?vue&type=template&id=436e07ea&"
import script from "./RecordedCleanupDialog.vue?vue&type=script&lang=ts&"
export * from "./RecordedCleanupDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports